import { validateNumberRange } from 'modules/workflowNodeEditors/utils';

import {
  RATE_LIMIT_RANGE_PER_MINUTE,
  RATE_LIMIT_RANGE_PER_SECOND,
  RATE_LIMIT_UNITS,
} from '../../BaseSendEditor.constants';
import { SendNodeValidation } from '../../BaseSendEditor.utils';
import { DEFAULT_LIMIT, DEFAULT_UNIT } from './RateLimitingCheckbox.constants';

const SECONDS_IN_MINUTE = 60;

export const getRateLimitPerMin = (limit: number, unit = DEFAULT_UNIT) =>
  unit === DEFAULT_UNIT ? limit : limit * SECONDS_IN_MINUTE;

export const createLimitSetting = (isChecked = true, limit = DEFAULT_LIMIT) =>
  isChecked ? { useRateLimit: true, rateLimitPerMin: limit } : null;

export const validationOptions = {
  [RATE_LIMIT_UNITS.SECOND]: RATE_LIMIT_RANGE_PER_SECOND,
  [RATE_LIMIT_UNITS.MINUTE]: RATE_LIMIT_RANGE_PER_MINUTE,
};

export const validateLimit = (limit: number, unit = DEFAULT_UNIT) => {
  const { hasError, message } = validateNumberRange(limit, validationOptions[unit]);
  return new SendNodeValidation(hasError, message);
};
